/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import TopOfPageBanner from './components/TopOfPageBanner';
import { useMatch } from 'react-router-dom';
import { SPA_PREFIX } from '~/dashboard/constants';

const PageSpecificBanner = () => {
  const match = useMatch(`${SPA_PREFIX}/workflows/:workflowToken/what-if/:analysisToken/evaluations/:evaluationToken`);
  return (
    <>
      { match && (
      <TopOfPageBanner>
        This evaluation was created as part of a test using cached data.
      </TopOfPageBanner>
      )}
    </>
  );
};

export default PageSpecificBanner;
